import React from "react";
import { coverBackgroundStyle } from "../lib/coverGradients";

/** Event cover header block with the stored gradient background. */
export default function CoverBlock({ coverColor, className = "", style, children, ...rest }) {
  return (
    <div
      className={className}
      style={{ ...coverBackgroundStyle(coverColor), ...style }}
      {...rest}
    >
      {children}
    </div>
  );
}
